import { render, staticRenderFns } from "./OffersEdit.vue?vue&type=template&id=6df873b9"
import script from "./OffersEdit.vue?vue&type=script&lang=js"
export * from "./OffersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports